var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.000976562C7.66344 0.000976562 0.5 7.16442 0.5 16.001V16.025C0.5 24.8616 7.63944 32.001 16.476 32.001H16.5C25.3366 32.001 32.5 24.8616 32.5 16.025V16.001C32.5 7.16442 25.3606 0.000976562 16.524 0.000976562H16.5Z",
    fill: "#E6F7FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22193_80749",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.00098H24.5V24.001H8.5V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22193_80749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.00098C12.0821 8.00098 8.5 11.5831 8.5 16.001C8.5 20.4189 12.0821 24.001 16.5 24.001C20.9179 24.001 24.5 20.4189 24.5 16.001C24.5 11.5831 20.9179 8.00098 16.5 8.00098ZM19.9554 13.3885L16.1946 18.6028C16.0814 18.7609 15.9275 18.8399 15.733 18.8399C15.5386 18.8399 15.3847 18.7609 15.2714 18.6028L13.0446 15.517C12.9768 15.4224 13.0446 15.2903 13.1607 15.2903H13.9982C14.1804 15.2903 14.3536 15.3778 14.4607 15.5278L15.7321 17.292L18.5393 13.3992C18.6464 13.251 18.8179 13.1617 19.0018 13.1617H19.8393C19.9554 13.1617 20.0232 13.2938 19.9554 13.3885Z",
    fill: "#1677FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedOutIcon);
export default __webpack_public_path__ + "static/media/signedOutIcon.34017f06519abd6493b7fbd0758f6e72.svg";
export { ForwardRef as ReactComponent };